const ENTITY_NAME = "Compute";
const COMPUTE_RESOURCE = "Compute resource";
const PAGE_TITLES = {
  create: `Register a compute resource`,
  view: `View compute resource`,
  list: `Manage compute resources`
};
var AuthenticationType = /* @__PURE__ */ ((AuthenticationType2) => {
  AuthenticationType2["ManagedIdentity"] = "ManagedIdentity";
  AuthenticationType2["ServicePrincipal"] = "ServicePrincipal";
  AuthenticationType2["Legacy"] = "Legacy";
  return AuthenticationType2;
})(AuthenticationType || {});
export {
  AuthenticationType,
  COMPUTE_RESOURCE,
  ENTITY_NAME,
  PAGE_TITLES
};
//# sourceMappingURL=ComputeResource.constants.js.map
